import TeamsContent from "./sections/TeamsContent/TeamsContent";
import TeamsHero from "./sections/TeamsHero/TeamsHero";

const Teams = () => {
  return (
    <div>
      <TeamsHero />
      <TeamsContent />
    </div>
  );
};

export default Teams;
